// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"Heading-module__sectionHeader___lD8Gd"};